!function (E) {
  var n = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
  E.languages.typoscript = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0
    }, {
      pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^"'])#.*/,
      lookbehind: !0,
      greedy: !0
    }],
    function: [{
      pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
      inside: {
        string: {
          pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
          inside: {
            keyword: n
          }
        },
        keyword: {
          pattern: /INCLUDE_TYPOSCRIPT/
        }
      }
    }, {
      pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
      inside: {
        string: /"[^"\r\n]*"|'[^'\r\n]*'/
      }
    }],
    string: {
      pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
      lookbehind: !0,
      inside: {
        function: /\{\$.*\}/,
        keyword: n,
        number: /^\d+$/,
        punctuation: /[,|:]/
      }
    },
    keyword: n,
    number: {
      pattern: /\b\d+\s*[.{=]/,
      inside: {
        operator: /[.{=]/
      }
    },
    tag: {
      pattern: /\.?[-\w\\]+\.?/,
      inside: {
        punctuation: /\./
      }
    },
    punctuation: /[{}[\];(),.:|]/,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
  }, E.languages.tsconfig = E.languages.typoscript;
}(Prism);